import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const PointsCash = ({ points, description, currencyName, onlyCash }) => {
  return (
    <div>
      <p className='txt-body-sm'> { onlyCash ? 'Veja quais bandeiras são aceitas.' : 'Complemente seu resgate com dinheiro.'}</p>
      <p className='txt-body-sm'>
        <strong>
          {`Resgate por ${points} ${currencyName} + ${description}`}
        </strong>
      </p>
    </div>
  )
}

PointsCash.propTypes = {
  points: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  currencyName: PropTypes.string.isRequired,
  onlyCash: PropTypes.bool
}

const mapStateToProps = ({ onlyCash }) => ({
  onlyCash
})
export default connect(
  mapStateToProps,
  null
)(PointsCash)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Payment/PointsCash/PointsCash.js